import Avatar from '@material-ui/core/Avatar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Paper from '@material-ui/core/Paper';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';
import LockIcon from '@material-ui/icons/LockOutlined';
import PropTypes from 'prop-types';
import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import GlobalStore, { StoreSubscribe } from '../../../providers/global-store-provider';
import { getAdminRoles, inIframe, Loader, postMessageToParent } from '../libs/helpers';
/*
-----------------------------------------------------------------------
Theming
-----------------------------------------------------------------------
*/
const styles = theme => ({
    main: {
        width: 'auto',
        display: 'block', // Fix IE 11 issue.
        marginLeft: theme.spacing(3),
        marginRight: theme.spacing(3),
        [theme.breakpoints.up(400 + theme.spacing(3) * 2)]: {
            width: 400,
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: `${theme.spacing(2)}px ${theme.spacing(3)}px ${theme.spacing(3)}px`,
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        marginTop: theme.spacing(3),
    },
});

/*
-----------------------------------------------------------------------
RENDER Functions
-----------------------------------------------------------------------
*/
function Error(props) {
    const { classes } = props;
    if (GlobalStore.state.auth.loggedIn) {
        if (inIframe()) {
            postMessageToParent('login', {
                loggedIn: true,
                userInfo: GlobalStore.state.auth.user
            });
            return <main className={classes.main}>
                <CssBaseline />
                <Paper className={classes.paper}>
                    <Avatar className={classes.avatar}>
                        <LockIcon />
                    </Avatar>
                    <p>Logging In</p>
                    <Loader size='40' />
                </Paper>
            </main>;
        }
        if (
            GlobalStore.state.auth.user.roles &&
            props.location.pathname.indexOf('/admin') !== -1
        ) {
            const roles = GlobalStore.state.auth.user.roles.filter(i => getAdminRoles().indexOf(i) !== -1)
            if (roles.length)
                GlobalStore.auth.setRole(roles[0]);
        }
    }

    return (
        <StoreSubscribe>
            {Store => {
                return (
                    <main className={classes.main}>
                        <CssBaseline />
                        <Paper className={classes.paper}>
                            <Avatar className={classes.avatar}>
                                <LockIcon />
                            </Avatar>
                            <Typography component="h1" variant="h5">
                                404 Page Not Found
                            </Typography>
                            <Typography component={Link} to='/' >
                                Go to home
                            </Typography>
                            {Store.state.auth.loggedIn &&
                                <Typography component={Link} to='/logout' >
                                    Logout
                                </Typography>
                            }
                        </Paper>
                    </main>
                )
            }}
        </StoreSubscribe>
    );
}

Error.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(withRouter(Error));